<template>
	<div>
		<AppDialog>
			<div class="text-align-left pa-6">
				<div class="dialog-body">
					<PreviewBox :title="`'${userSelectedHeader}' column preview`" class="mt-2">
						<div>
							<div v-for="(row, index) in columnsToPreview" :key="index" class="mx-1 my-2">{{ row || ' ' }}</div>
						</div>
					</PreviewBox>
				</div>
			</div>
		</AppDialog>
	</div>
</template>

<script>
import PreviewBox from '@/components/common/PreviewBox';

import AppDialog from '../AppDialog/AppDialog';

export default {
	name: 'ColumnsPreviewDialog',
	components: {
		AppDialog,
		PreviewBox,
	},
	props: {
		userSelectedHeader: { type: String },
		columnsSample: { type: Array },
	},
	computed: {
		columnsToPreview() {
			return this.columnsSample.slice(0, 5);
		},
	},
};
</script>

<style scoped lang="scss"></style>
